import React, {Component} from 'react'
import {connect} from 'react-redux'
import propTypes from 'prop-types'
import {has, find, isNil, get} from 'lodash'
import Popover from '@material-ui/core/Popover'
import Button from 'components/button'
import TreeSearcher, {TreeListType} from 'components/treeSearcher'
import {loadCampaignGroups, loadCampaigns} from "actions/data"

class CampaignSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      selectedCampaign: (has(props, 'value')) ? this.findCampaign(props.value) : null,
      anchorEl: null,
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.campaignGroups.length === 0) {
      this.props.load()
    }
  }

  handleTouchTap = (event) => {
    event.preventDefault()
    this.setState({
      ...this.state,
      open: !this.state.open,
      anchorEl: event.currentTarget,
    })
  }

  handleRequestClose = () => {
    this.setState({
      ...this.state,
      open: false,
      anchorEl: null,
    })
  }

  handleOnChange = (id) => {
    this.setState({
      selectedCampaign: this.findCampaign(id),
      open: false,
    })
    if (typeof this.props.onChange !== 'undefined') {
      this.props.onChange(id)
    }
  }

  findCampaign = (id) => find(this.props.campaigns, ['id', id])

  render() {
    const {disabled} = this.props

    if (disabled) {
      return (
        <Button
          label={isNil(this.state.selectedCampaign) ? 'None' : this.state.selectedCampaign.label}
          disabled={true}
        />
      )
    }

    const label = isNil(this.state.selectedCampaign) === false
      ? this.state.selectedCampaign.label
      : 'Select a campaign'

    return (
      <div>
        <Button label={label} onClick={this.handleTouchTap}/>
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          disableEnforceFocus={true}
          anchorOrigin={{horizontal: 'left', vertical: 'top'}}
          transformOrigin={{horizontal: 'left', vertical: 'top'}}
          onClose={this.handleRequestClose}
          onClick={(e) => e.stopPropagation()}
          disableRestoreFocus={true}>
          <div style={{width: 300, height: 300}}>
            <TreeSearcher
              parentLabel="All Campaigns"
              folders={this.props.campaignGroups}
              options={this.props.campaigns}
              listType={TreeListType.FLAT}
              onChange={this.handleOnChange}
            />
          </div>
        </Popover>
      </div>
    )
  }
}

CampaignSelector.propTypes = {
  value: propTypes.number,
  campaigns: propTypes.array,
  campaignGroups: propTypes.array,
  disabled: propTypes.bool,
  load: propTypes.func,
  onChange: propTypes.func,
}

const mapStateToProps = (state) => {
  return {
    campaigns: get(state, 'data.campaigns').map(c => ({
      id: c.id,
      label: c.name,
      parentId: c.parentGroupId,
    })),
    campaignGroups: get(state, 'data.campaignGroups').map(c => ({
      id: c.id,
      label: c.name,
      parentId: c.parentGroupId,
    })),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    load: () => {
      dispatch(loadCampaignGroups())
      dispatch(loadCampaigns())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignSelector)
